import {createFileRoute, Outlet, redirect} from '@tanstack/react-router';
import {auth} from '@resurs-internal/rb-app-api/features/auth/auth';
import {isOpenBankingCallbackPath} from '../services/uri/isOpenBankingCallbackPath';

export const Route = createFileRoute('/_protected')({
  beforeLoad: ({location}) => {
    // Skip the guard for open-banking return paths: the user may have spent a long time
    // on an external bank page, causing their access token to expire and triggering an
    // auth.reset(). Redirecting them to logout here would be a violent UX — the callback
    // pages handle expired-session state gracefully via AuthRefreshDialog.
    if (
      !auth.state?.isLoggedIn &&
      !isOpenBankingCallbackPath(location.pathname)
    ) {
      sessionStorage.setItem('redirect', location.pathname);
      throw redirect({to: '/logout'});
    }
  },
  component: Outlet,
});
